// Konstanten & Styles für das Admin-Panel.

export const ALLOWED_TABLES = [
    'nutzer', 'uebungen', 'nutzer_eigene_uebungen', 'trainings_ergebnisse'
];

export const darkCard = {
    borderRadius: '16px',
    background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 100%)',
    border: '1px solid rgba(59, 130, 246, 0.2)',
};

export const btnSx = {
    fontWeight: 600, borderRadius: '12px', textTransform: 'none',
    background: 'linear-gradient(135deg, #1e3a8a 0%, #3b82f6 100%)',
    color: '#fff', transition: 'all 0.2s ease',
    '&:hover': { background: 'linear-gradient(135deg, #3b82f6 0%, #1e3a8a 100%)', transform: 'translateY(-1px)' },
    '&:disabled': { opacity: 0.45 },
};

export const inputSx = {
    '& .MuiOutlinedInput-root': {
        fontSize: '13px',
        background: '#1e293b',
        '& fieldset': { borderColor: 'rgba(59,130,246,0.2)' },
        '&:hover fieldset': { borderColor: 'rgba(59,130,246,0.4)' },
        '&.Mui-focused fieldset': { borderColor: 'rgba(59,130,246,0.6)' },
    },
    '& .MuiInputLabel-root': { fontSize: '13px', color: '#64748b' },
    '& .MuiSelect-select': { fontSize: '13px' },
};
